"use strict";
exports.__esModule = true;
exports.HeadlinePagination = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var HeadlinePaginationRenderer_1 = require("./HeadlinePaginationRenderer");
/**
 * @internal
 */
exports.HeadlinePagination = function (_a) {
    var renderSecondaryItem = _a.renderSecondaryItem, renderTertiaryItem = _a.renderTertiaryItem;
    var _b = react_1.useState(1), item = _b[0], setItem = _b[1];
    var showNextItem = function () { return setItem(item + 1); };
    var showPrevItem = function () { return setItem(item - 1); };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(HeadlinePaginationRenderer_1.HeadlinePaginationRenderer, { item: item, showNextItem: showNextItem, showPrevItem: showPrevItem }),
        item === 1 && renderSecondaryItem(),
        item === 2 && renderTertiaryItem()));
};
//# sourceMappingURL=HeadlinePagination.js.map